import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { dataUpdatePassword } from 'src/app/models/dataUpdatePassword';
import { AlertifyService } from 'src/app/services/alertify.service';

@Component({
  selector: 'app-restorepassword',
  templateUrl: './restorepassword.component.html',
  styleUrls: ['./restorepassword.component.scss'],
})
export class RestorepasswordComponent implements OnInit {
  public Id = '';
  public Email = '';
  public restorePwdString = '';
  registerForm: UntypedFormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    public router: Router,
    public userSvc: UserService,
    private alertify: AlertifyService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.Id = params['id'];
      this.Email = params['email'];
      this.restorePwdString = params['cadenapwd'];

      console.log('usrId', this.Id);
      console.log('email', this.Email);
      console.log('restorePwdString', this.restorePwdString);

      if (
        this.Id == undefined ||
        this.Email == undefined ||
        this.restorePwdString == undefined ||
        this.Id == '' ||
        this.Email == '' ||
        this.restorePwdString == ''
      ) {
        this.router.navigate(['']);
      }
    });
  }

  ngOnInit(): void {
    this.registerForm = new UntypedFormGroup({
      password: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(8),
      ]),
      passwordCnf: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(8),
      ]),
    });
  }

  getValidationErrorPassword() {
    if (this.registerForm.get('password')?.hasError('required')) {
      return 'El campo es requerido';
    }
    if (this.registerForm.get('password')?.hasError('minlength')) {
      return 'La contraseña debe ser mayor a 8 caracteres';
    }
    if (this.registerForm.get('password')?.hasError('pattern')) {
      return 'La contraseña no es segura, debe tener almenos: una mayúscula, una minúscula y un número';
    }
    return '';
  }

  validatePwdEquality() {
    if (this.registerForm.get('passwordCnf')?.hasError('required')) {
      return 'El campo es requerido';
    }
    if (
      this.registerForm.get('password')?.value !==
      this.registerForm.get('passwordCnf')?.value
    ) {
      this.registerForm
        .get('passwordCnf')
        ?.setErrors({ pattern: 'No coinciden' });
      return 'Las contraseñas no coinciden';
    }
    return '';
  }

  restorePwd() {
    if (this.registerForm.valid) {
      //mando a guardar
      console.log('mando a guardar');
      const dataUpdPwd: dataUpdatePassword = {
        id: this.Id,
        email: this.Email,
        cadenaRecuperarPassword: this.restorePwdString,
        password: this.registerForm.get('password')?.value,
      };

      this.userSvc.ActualizarPassword(dataUpdPwd).subscribe((res) => {
        if (res) {
          this.alertify.success('Cambios realizados');
          this.router.navigate(['']);
        } else {
          this.alertify.error('Error al realizar los cambios');
        }
      });
    }
  }
}
